import Beard from 'https://github.com/miru-media/static-assets/raw/0e9bf5c/dist/gltf/effects/Beard.glb'
import Cat from 'https://github.com/miru-media/static-assets/raw/0e9bf5c/dist/gltf/effects/Cat.glb'
import Clown from 'https://github.com/miru-media/static-assets/raw/0e9bf5c/dist/gltf/effects/Clown.glb'
import Eyes from 'https://github.com/miru-media/static-assets/raw/0e9bf5c/dist/gltf/effects/Eyes.glb'
import Makeup from 'https://github.com/miru-media/static-assets/raw/0e9bf5c/dist/gltf/effects/Makeup.glb'
import Rain from 'https://github.com/miru-media/static-assets/raw/0e9bf5c/dist/gltf/effects/Rain.glb'
import Teddy from 'https://github.com/miru-media/static-assets/raw/0e9bf5c/dist/gltf/effects/Teddy.glb'

export const catalog = [
  { name: 'Cat', url: Cat },
  { name: 'Stash', url: Beard },
  { name: 'Clown', url: Clown },
  { name: 'Eyes', url: Eyes },
  { name: 'Make-up', url: Makeup },
  { name: 'Rain', url: Rain },
  { name: 'Teddy', url: Teddy },
]
